export default __webpack_public_path__ + "static/app-features-5-2e3926cac08483485b2028289e03de8a.png";